import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import CompoundInfo from "@/modules/lead-page/new/components/sidebar/fields/linked-location/compound-info";
import { Box, Typography, useTheme } from "@mui/material";
import { useContext } from "react";

const LeadLocation = () => {
  const { lead } = useContext(LeadPageContext);
  const theme = useTheme();

  const renderContent = () => {
    return <CompoundInfo compoundId={lead?.data?.lead?.location?.compoundId} />;
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        alignItems: "flex-start",
        width: "100%",
      }}
    >
      {!lead?.data.lead.location?.uid && (
        <Typography
          sx={{
            width: "100%",
            textAlign: "left",
            color: theme.nawy.colors.semantic.text.primary,
            ...theme.nawy.typography.english.variants.body.md.regular,
          }}
        >
          No location
        </Typography>
      )}
      {lead?.data.lead.location?.uid && renderContent()}
    </Box>
  );
};

export default LeadLocation;
